import {NamedTranslation} from "./locale";
import {License} from "./src/license";

export interface Config {
  siteKey: string;
  privacyUrl: string;
  apiUrl: string;
  framework: string | null;
  language: string;
  theme: 'light' | 'dark' | 'media';
  currentTheme: 'light' | 'dark';
  autostartDisabled: boolean;
  tokenFieldName: string;
  bypassToken: string | null;
  minimalDataMode: boolean;
  fullWidth: boolean;
  translation: NamedTranslation;
  whiteLabel: boolean;
  invisible: boolean;
  failoverEnabled: boolean;
  licenseObject?: License;
}
